module.exports = __webpack_public_path__ + "static/media/aquarium.ee3e8bd3.png";